import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["selector", "form", "selectorInput", "formInput"]

  connect() {
    // Initialize the form state
    this.showSelector()
  }

  toggle(event) {
    event.preventDefault()
    
    if (this.selectorTargets[0].style.display === "none") {
      this.showSelector()
    } else {
      this.showForm()
    }
  }

  showSelector() {
    // Show the selector and hide the form
    this.selectorTargets.forEach(target => target.style.display = "")
    this.formTargets.forEach(target => target.style.display = "none")
    
    // Enable the selector input and disable the form input
    if (this.hasSelectorInputTarget) {
      this.selectorInputTarget.disabled = false
    }
    
    if (this.hasFormInputTarget) {
      this.formInputTarget.disabled = true
      this.formInputTarget.value = "" // Clear the form input
    }
  }

  showForm() {
    // Show the form and hide the selector
    this.selectorTargets.forEach(target => target.style.display = "none")
    this.formTargets.forEach(target => target.style.display = "")
    
    // Disable the selector input and enable the form input
    if (this.hasSelectorInputTarget) {
      this.selectorInputTarget.disabled = true
      this.selectorInputTarget.value = "" // Clear the selector input
    }
    
    if (this.hasFormInputTarget) {
      this.formInputTarget.disabled = false
    }
  }
} 